/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @enum {string}
 */
export enum InvoiceAuditProblemResolutionState {
  Unresolved = "unresolved",
  Pending = "pending",
  Resolved = "resolved",
}

export function instanceOfInvoiceAuditProblemResolutionState(
  value: any,
): boolean {
  for (const key in InvoiceAuditProblemResolutionState) {
    if (
      Object.prototype.hasOwnProperty.call(
        InvoiceAuditProblemResolutionState,
        key,
      )
    ) {
      if (
        InvoiceAuditProblemResolutionState[
          key as keyof typeof InvoiceAuditProblemResolutionState
        ] === value
      ) {
        return true;
      }
    }
  }
  return false;
}

export function InvoiceAuditProblemResolutionStateFromJSON(
  json: any,
): InvoiceAuditProblemResolutionState {
  return InvoiceAuditProblemResolutionStateFromJSONTyped(json, false);
}

export function InvoiceAuditProblemResolutionStateFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): InvoiceAuditProblemResolutionState {
  return json as InvoiceAuditProblemResolutionState;
}

export function InvoiceAuditProblemResolutionStateToJSON(
  value?: InvoiceAuditProblemResolutionState | null,
): any {
  return value as any;
}

export function InvoiceAuditProblemResolutionStateToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): InvoiceAuditProblemResolutionState {
  return value as InvoiceAuditProblemResolutionState;
}
